













































import Vue from "vue"

import CorrectIcon from "@/components/correct-icon/correct-icon.vue"
import ImageLink from "@/components/image-link/image-link.vue"
import Bookmark from "./bookmark.vue"

import { addQuestionBookmark, deleteQuestionBookmark } from "@/api/question"

export default Vue.extend({
  props: {
    questions: {
      type: Array as Prop<api.unitImpl.Question[]>,
      required: true
    },
    unit: {
      type: Object as Prop<api.unit.GetUnitResponseData>,
      required: true
    }
  },

  components: {
    CorrectIcon,
    ImageLink,
    Bookmark
  },

  computed: {
    isLocked(): boolean {
      // 契約が切れている場合は内容は見れない
      return this.unit.grade !== 0 && this.unit.impl.is_locked
    }
  },

  methods: {
    handleUpdateBookmark(question: api.unitImpl.Question) {
      this.$store.dispatch("clearMessage")

      const method = question.is_bookmarked
        ? addQuestionBookmark
        : deleteQuestionBookmark

      method(question.id).then(() => {
        return "update bookmark success"
      })
    },

    clickCheckIcon(question: api.unitImpl.Question) {
      this.$emit("click-check-icon", question)
    }
  }
})
